import { Tooltip } from "react-tooltip";
import QuestionMarkIcon from "../../../../../assets/icons/icon-question-mark.svg";

interface IToolTipInfo {
    text: string;
    tooltipId: string;
}

export default function ToolTipInfo({ text, tooltipId }: IToolTipInfo) {
    return (
        <>
            <span 
                className="tooltip-info__trigger"
                data-tooltip-id={tooltipId}
                data-tooltip-content={text}
            >
                <img 
                    src={QuestionMarkIcon} 
                    alt="View information" 
                    className="tooltip-info__icon"
                />
            </span>
            <Tooltip 
                id={tooltipId}
                className="tooltip-info-tooltip"
                place="left"
            />
        </>
    )
}
